import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    id: 1,
    question: "How does the AI design process work?",
    answer:
      "Simply describe what you want, and our AI will generate custom designs based on your text prompt. You can then refine and customize before ordering.",
  },
  {
    id: 2,
    question: "What types of products can I create?",
    answer:
      "You can create any design you can imagine! Our platform supports stickers, mugs, t-shirts, hoodies, tote bags, phone cases, posters, hats, and many more products for personal use, gifts, or business branding.",
  },
  {
    id: 3,
    question: "How long does shipping take?",
    answer:
      "Standard shipping typically takes 5-7 business days within the US. Expedited options are available at checkout.",
  },
  {
    id: 4,
    question: "What's the quality of the products?",
    answer:
      "All our products are made with premium materials through our partnership with Printify. Stickers are waterproof and scratch-resistant vinyl. Apparel uses high-quality fabrics and printing. We guarantee professional results.",
  },
  {
    id: 5,
    question: "Can I use my own images instead of AI?",
    answer:
      "Yes! While our AI design tool is a powerful feature, you can also upload your own images and artwork to use on any of our products.",
  },
  {
    id: 6,
    question: "What if I'm not satisfied with my order?",
    answer:
      "We stand behind our quality. If you're not completely satisfied with your order, contact us within 30 days and we'll make it right with a replacement or refund.",
  },
];

export function FAQSection() {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  return (
    <section className="py-16 px-4 bg-muted/30">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12 sm:mb-16 space-y-4 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">Frequently Asked Questions</h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            Get answers to common questions about our AI-powered custom products
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={faq.id} className="mb-4">
              <button
                className="flex justify-between items-center w-full text-left p-4 sm:p-5 bg-background rounded-lg shadow-sm hover:shadow-md transition-shadow"
                onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
              >
                <span className="text-sm sm:text-base font-semibold pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 transition-transform flex-shrink-0 ${
                    expandedFaq === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              {expandedFaq === index && (
                <div className="mt-2 p-4 sm:p-5 bg-background rounded-lg shadow-sm">
                  <p className="text-sm sm:text-base text-muted-foreground">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
